<template>
    <div class="container-fluid overflow-hidden">
        <div class="row vh-100 overflow-auto" @scroll="scrollEvent">
            <aside class="col-12 col-sm-4 col-xl-2 px-sm-2 px-0 bg-primary d-flex sticky-top" style="border-right : 4px solid var(--bs-gray-800);">
                <nav aria-label="Sections du CV" class="d-flex flex-sm-column flex-row flex-grow-1 align-items-center text-white">

                    <template v-if="!verticalBreakpoint">
                        <img src="@/assets/images/avatar.jpg" :alt="datas.about.name + ', ' + datas.about.function" class="img-thumbnail rounded-circle w-75 d-none d-sm-block shadow" style="max-width:200px;" :style="{ marginTop : menuMarginTop+'px'}" >
                    </template>

                    <a href="/" class="d-flex align-items-center text-white text-decoration-none mt-sm-3 mb-sm-5">
                        <b class="d-none d-sm-inline"><span class="fs-5">{{ datas.about.name }}</span></b>
                    </a>

                    <ul class="nav nav-pills flex-sm-column flex-row flex-nowrap flex-shrink-1 flex-sm-grow-0 flex-grow-1 mb-sm-auto mb-0 justify-content-center align-items-center align-items-sm-start" id="menu">

                        <template v-for="(section, sectionIndex) in sections" :key="'sidebar_section_' + sectionIndex">
                            <li class="nav-item w-100 px-sm-4 px-1 rounded"  :class="{ visible : section.visible }">
                                <a :href="'#' + section.id" @click.prevent="goToSection(section.id)" class="nav-link px-sm-0 px-2 text-white" >
                                    <i class="text-white me-2 fs-5" :class="section.icon"></i>
                                    <span class="ms-1 d-none d-sm-inline">{{ section.name }}</span>
                                </a>
                            </li>
                        </template>

                    </ul>
                </nav>
            </aside>
            <div class="col d-flex flex-column h-sm-100">
                <main class="row overflow-auto bg-secondary">
                    <div class="col p-0">

                        <section :id="section.id" v-for="(section, sectionIndex) in sections" :key="'content_section_' + sectionIndex" ref="content_sections" :aria-labelledby="section.id + '-title'" class='content_section p-sm-5 p-3 d-flex align-items-center'>

                            <template v-if="section.component != null">
                                <component :is="section.component" :section="section"></component>
                            </template>

                        </section>

                    </div>
                </main>
                <footer class="row bg-secondary p-3 mt-auto" style='border-top: 2px solid #d8d8d8;'>
                    <div class="col-lg-6 col-12 text-center">
                        <span style="color:#AAA;">{{ datas.credits }}</span>
                    </div>
                    <div class="col-lg-6 col-12 text-center">
                        <a class="text-dark text-decoration-none fw-bold" :href="datas.about.url_web">{{ datas.about.name }}</a>
                    </div>
                </footer>
            </div>
        </div>
    </div>
</template>

<script>
import SectionAbout from "./SectionAbout.vue"
import SectionSkills from "./SectionSkills.vue"
import SectionCareer from "./SectionCareer.vue"
import SectionCourses from "./SectionCourses.vue"
import SectionPersonal from "./SectionPersonal.vue"


export default {
    name: 'Layout',
    components: {
        SectionAbout, SectionSkills, SectionCareer, SectionCourses, SectionPersonal
    },
    data : function() {
        return {
            menuMarginTop : window.innerHeight * 0.15,
            verticalBreakpoint : false,

            sections : [
                {
                    "id": "about",
                    "component": "SectionAbout",
                    "icon": "bi-person",
                    "name": "À propos",
                    "visible": true
                },
                {
                    "id": "skills",
                    "component": "SectionSkills",
                    "icon": "bi-card-checklist",
                    "name": "Compétences"
                },
                {
                    "id": "career",
                    "component": "SectionCareer",
                    "icon": "bi-briefcase",
                    "name": "Expériences"
                },
                {
                    "id": "courses",
                    "component": "SectionCourses",
                    "icon": "bi-easel",
                    "name": "Formations"
                },
                {
                    "id": "personal",
                    "component": "SectionPersonal",
                    "icon": "bi-pen",
                    "name": "Notes personnelles"
                }
            ],
        }
    },
    mounted : function() {
        window.addEventListener('resize', this.resizeEvent);

        this.scrollEvent();
    },
    methods : {
        scrollEvent : function (target = null) {
            let scroll = target == null ? 0 : target.srcElement.scrollTop;

            this.menuMarginTop = scroll + window.innerHeight * 0.15;

            this.sections.forEach((section, sectionIndex) => {
                section.position = this.$refs.content_sections[sectionIndex].offsetTop;
                section.height = this.$refs.content_sections[sectionIndex].clientHeight;
                section.visible =
                (
                    section.position < (scroll + window.innerHeight) && section.position + section.height >= (scroll)
                    &&
                    (this.sections[sectionIndex -1] == undefined || this.sections[sectionIndex -1].visible == false)
                );
            });
        },
        resizeEvent : function () {
            this.verticalBreakpoint =  window.innerHeight < 500;
        },
        goToSection(sectionId) {
            document.getElementById(sectionId).scrollIntoView({ behavior: 'smooth' });
        }
    },
    computed : {
    }
}
</script>

<style scoped>


.nav-item.visible {
    background-color: var(--bs-gray-800);
}

.nav-link:hover {
    color:var(--bs-gray-500) !important;
}

.content_section {
    background-color:white;
    min-height:100vh;
    border-bottom:1px solid #CCC;
    width:100%;
}
</style>
